module.exports = __webpack_public_path__ + "img/partner_logo14.5f1b6533.png";